import React from "react";

import { docLink } from "@common/util/docs";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { MetricCardEmptyState } from "@main/pages/Release/views/MetricCards/MetricCardEmptyState";
import * as Styled from "@main/pages/Release/views/MetricCards/NetworkSpeedCard.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { EndpointUrl } from "@main/pages/Release/views/MetricDetails/shared/EndpointUrl";

interface NetworkSpeedCardProps extends ReleaseMetricCardBaseProps {
  data: EndpointSpeedData[];
}

const NetworkSpeedCard = ({ style, data, score, highlight, error, onMoreClick }: NetworkSpeedCardProps) => {
  const isEmpty = data?.length === 0;

  const { selectedApp } = useAppSelectionContext();
  const platform = selectedApp?.platform?.name;

  return (
    <ReleaseMetricCard
      style={style}
      title={"Network traffic speed"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      {!isEmpty ? (
        <Styled.EndpointList>
          {data.map((endpoint) => (
            <Styled.EndpointRow key={`${endpoint.method}-${endpoint.url}`}>
              <Styled.TimeText
                p2
                $isError={endpoint.isError}
              >{`${endpoint.time.toFixed(0)} ms`}</Styled.TimeText>
              <div style={{ marginLeft: "1.6rem", marginRight: "0.8rem" }}>
                <Styled.Badge>{endpoint.method}</Styled.Badge>
              </div>
              {/*{endpoint.isError ? (*/}
              {/*  <Styled.ErrorIconWrapper>*/}
              {/*    <img*/}
              {/*      src={ErrorIcon}*/}
              {/*      alt="error"*/}
              {/*    />*/}
              {/*  </Styled.ErrorIconWrapper>*/}
              {/*) : (*/}
              {/*  hasWarning(endpoint) && (*/}
              {/*    <Styled.WarningIconWrapper>*/}
              {/*      <WarningIcon />*/}
              {/*    </Styled.WarningIconWrapper>*/}
              {/*  )*/}
              {/*)}*/}
              <EndpointUrl
                url={endpoint.url}
                isError={endpoint.isError}
                compact
              />
            </Styled.EndpointRow>
          ))}
        </Styled.EndpointList>
      ) : (
        <MetricCardEmptyState
          text={"No network traffic recorded yet. If you haven't already, enable it in your SDK."}
          buttonText={"Enable network traffic"}
          onButtonClick={() => window.open(docLink(platform).networkTraffic, "_blank")?.focus()}
          column
        />
      )}
    </ReleaseMetricCard>
  );
};

export interface EndpointSpeedData {
  url: string;
  method: string;
  time: number;
  isError?: boolean;
  score?: number | null;
}

export { NetworkSpeedCard };
